import { TERMS_OF_SERVICE_URL } from "@/data/constants/policy-links";
import { DEFAULT_LANGUAGE, getSelectedLanguageCode } from "@/utils/language-util";

/**
 * 서비스 이용 약관 URL을 가져오는 usecase
 */
export class GetTermsOfServiceUrlUsecase {
  /**
   * 사용자가 선택한 언어에 따라 서비스 이용 약관 페이지 URL을 반환합니다.
   * @returns 서비스 이용 약관 페이지 URL
   */
  execute(): string {
    // 지원하지 않는 언어는 한국어 기본값 사용
    return TERMS_OF_SERVICE_URL[getSelectedLanguageCode()] ?? TERMS_OF_SERVICE_URL[DEFAULT_LANGUAGE];
  }
}
